var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 60,
    viewBox: "0 0 38 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5452 59.121H7.12099C4.00813 59.121 1.48462 56.5975 1.48462 53.4846V21.5454C1.48462 18.4326 4.00813 15.9091 7.12099 15.9091H31.5452C34.6581 15.9091 37.1816 18.4326 37.1816 21.5454V53.4846C37.1815 56.5975 34.6581 59.121 31.5452 59.121Z",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6062 12.1515H8.06076C7.02318 12.1515 6.18201 11.3103 6.18201 10.2728V2.75753C6.18201 1.71996 7.02318 0.878784 8.06076 0.878784H30.6061C31.6437 0.878784 32.4849 1.71996 32.4849 2.75753V10.2727C32.485 11.3103 31.6438 12.1515 30.6062 12.1515Z",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93925 12.1515L8.99988 15.909",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7273 12.1515L29.6667 15.909",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 21.5454H37.1815",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48474 21.5454H5.24224",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.48474 53.4847H37.1815",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0907 41.2726H27.7877C28.8253 41.2726 29.6665 40.4314 29.6665 39.3939V35.6363C29.6665 34.5986 28.8253 33.7575 27.7877 33.7575H23.0907V29.0605C23.0907 28.0228 22.2496 27.1818 21.212 27.1818H17.4544C16.4168 27.1818 15.5756 28.0229 15.5756 29.0605V33.7575H10.8786C9.84105 33.7575 8.99988 34.5987 8.99988 35.6363V39.3939C8.99988 40.4314 9.84105 41.2726 10.8786 41.2726H15.5756V45.9696C15.5756 47.0072 16.4168 47.8484 17.4544 47.8484H21.212C22.2496 47.8484 23.0907 47.0072 23.0907 45.9696V45.0302",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4546 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6971 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93958 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7273 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9697 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2122 0.878784V8.3939",
    stroke: "#188BF6",
    strokeWidth: 1.54839,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeds);
export default __webpack_public_path__ + "static/media/meds.a71c0720ff2ff2ba1cf6f79680522453.svg";
export { ForwardRef as ReactComponent };